// FILECONTENT_START src/common/components/Calendar/CalendarCellHeader.tsx
import { Box, BoxProps, styled, Typography } from "@mui/material";
import { CalendarCellItem, VIEWS } from "./calendarApi";

const CellHeader = styled(Box)<BoxProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: ${props => props.theme.spacing(0.5)};
`;

export interface CalendarCellHeaderProps extends CalendarCellItem {
  view: VIEWS;
}

export default function CalendarCellHeader({
  view,
  moment,
  isSelected,
  dayOfMonth,
}: CalendarCellHeaderProps) {
  if (view === VIEWS.MONTH) {
    return (
      <CellHeader>
        <Typography variant="body1" color={isSelected ? "white" : undefined}>
          {dayOfMonth}
        </Typography>
      </CellHeader>
    );
  } else if (view === VIEWS.WEEK) {
    return (
      <CellHeader>
        <Typography variant="body1">{moment.format("dddd LL")}</Typography>
      </CellHeader>
    );
  } else if (view === VIEWS.WORK_WEEK) {
    return null;
    /*return (
      <div className={classes.dayHeader}>
        <Text variant="text">{day.dayOfMonth}</Text>
      </div>
    );*/
  } else if (view === VIEWS.DAY) {
    return (
      <CellHeader>
        <Typography variant="body1">{moment.format("dddd LL")}</Typography>
      </CellHeader>
    );
  } else if (view === VIEWS.AGENDA) {
    return (
      <CellHeader>
        <Typography variant="body2">{moment.format("dddd")}</Typography>
        <Typography variant="body2">{moment.format("L")}</Typography>
      </CellHeader>
    );
  }
  return null;
}

// FILECONTENT_END src/common/components/Calendar/CalendarCellHeader.tsx